import { Component, OnInit, signal } from "@angular/core";
import { switchMap } from "rxjs/operators";
import {
  ExternalpageService,
  externalpageTypes,
  externalpageImageTypes,
} from "../../shared/services/externalpage.service";
import { ExternalpageOverview } from "../../class/externalpage-overview";
import { DomainService } from "../../shared/services/domain.service";
import { EventService } from "../../shared/services/event.service";

@Component({
  selector: "app-page-events",
  templateUrl: "./page-events.component.html",
  styleUrls: ["./page-events.component.scss"],
  standalone: false,
})
export class PageEventsComponent
  extends ExternalpageOverview
  implements OnInit
{
  externalpageTypes = externalpageTypes;
  externalpageImageTypes = externalpageImageTypes;

  public nodes: any = [];

  public view = {
    pageType: externalpageTypes.Event,
    queryParams: {
      pageSize: 100,
      pageNumber: 1,
      totalItems: 0,
    },
    data: <any[]>[],
  };

  eventsNew = signal<any[]>([]);
  eventsOld = signal<any[]>([]);

  /**
   * Constructor
   *
   * @param ExternalpageService externalpageService
   */
  constructor(
    public externalpageService: ExternalpageService,
    public eventService: EventService,
    protected domain: DomainService
  ) {
    super(externalpageService, domain);
  }

  /**
   * Ng on init
   */
  ngOnInit(): void {
    this.getEvents();
  }

  /**
   * Generate the appropriate link for an event node
   * @param node - The event node object
   * @returns The formatted link path
   */
  getLink(node: any): string {
    if (!node) {
      return "/events";
    }

    // Handle special permalinks that start with ~ (external/absolute links)
    if (node.permalink && node.permalink.startsWith("~")) {
      return "/" + node.permalink.substring(1);
    }

    // Use permalink if available, otherwise fall back to ID
    const identifier = node.permalink || node.id;

    if (!identifier) {
      return "/events";
    }

    return `/events/${identifier}`;
  }

  getEvents() {
    this.isLoading.set(true);

    this.targetGroupService.getDefaultTargetGroups$('externalpage').pipe(
      switchMap(targetGroups => {
        const targetGroup = targetGroups?.[0] ?? null;
        return this.externalpageService.apiGetExternalPageType(
          this.view.pageType,
          this.view.queryParams,
          this.domain.getCurrentRegion(),
          targetGroup
        );
      })
    ).subscribe((response: any) => {
        this.isLoading.set(false);

        if (response.hasOwnProperty("totalItems")) {
          this.view.queryParams.totalItems = response.totalItems;
        }
        if (response.hasOwnProperty("data")) {
          const events: any[] = Object.assign([], response.data);

          if (events.length > 0) {
            for (const i in events) {
              if (events[i]["imageReferences"].length > 0) {
                for (const image of events[i]["imageReferences"]) {
                  if (
                    image["imageType"] == this.externalpageImageTypes.MainImage
                  ) {
                    events[i]["imageUri"] = image["imageUri"];
                  }
                }
              }
            }
          }

          const eventsGrouped = this.eventService.groupEvents(events);

          this.view.data = Object.assign([], events);
          this.eventsNew.set(eventsGrouped.new);
          this.eventsOld.set(eventsGrouped.old);
        }
      });
  }
}
